export const CHAT_ENABLED_PAGES = [
  'partner-excelity',
  'partner-infosys',
  'partner-adp',
  'partner-siemens',
  'partner-wns',
  'partner-keka-filing',
  'partner-keka',
  'partner-peoplestrong',
  'partner-peopleworks-users/',
  'partner-upstox',
  'partner-angelone',
  'partner-gosats',
  'partner-get-simpl',
  'partner-paytm-money',
  'partner-pluxee-users',
  'partner-hrone-ct/',
  'partner-hrone',
  'partner-idfc',
  'partner-sbi',
  'partner-federal-bank',
];
